<section class="container">
    <h3 class="h3 font-weight-semi-bold pt-3">{{ title }}</h3>
    <blogEntry-list></blogEntry-list>
    <!--<button class="btn btn-success btn-sm" (click)="onBlogEntryAdd()">Add New Blog</button>-->
    <!--<a class="btn btn-success btn-sm" routerLink="addBlog">Add New Blog</a>-->
</section>